import { SchemaDefinition } from "../validator/schema-definition-interface";

/**
 * The schema definition for the stored piece object.
 */
export const storedPieceSchema: SchemaDefinition = {
	Name: 'stored-piece',
	Properties: {
		PieceId: { Type: 'object' },
		Dimensions: { Type: 'object' },
		DescriptionOfGoods: { Type: 'string' },
		Hazmat: { Type: 'object' },
		Quantity: { Type: 'number' },
		ReferenceNumber: { Type: 'string' }
	}
}